module.exports = __webpack_public_path__ + "img/ditto-logo-mark-light.51e2ed29.svg";